import { LitElement, html, svg } from 'lit';

export class IconUpload16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Pil opp fra harddisk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 10V2M5 5l3-3 3 3M1 11v.943c0 .545.197 1.069.547 1.454.35.386.825.603 1.32.603h10.266c.495 0 .97-.217 1.32-.603.35-.385.547-.909.547-1.454V11"></path></svg>`; }
}
if (!customElements.get('f-icon-upload16', IconUpload16)) {
  customElements.define('f-icon-upload16', IconUpload16);
}